import { Injectable, Inject /*Inject api config*/ } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { APP_CONFIG, apiUrl } from '../app.config';
import { IAppConfig } from '../iapp.config';
import { OpaqueToken } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from './data.service';

@Injectable()
export class MakerService {
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig,
    private router: Router,
    private _data: DataService
  ) {}
  static headers = new Headers({ 'Content-Type': 'application/json' });
  getMakerList() {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(this.config.apiEndpoint + '/car/makers?q=displayKbn=3', {
        headers: headers
      })
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getModelList(makerCd: string) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        this.config.apiEndpoint +
          '/car/models?q=modelDisplayKbn%3D3,makerCd%3D' +
          makerCd +
          ' ',
        {
          headers: headers
        }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  private handleError(error: any | any) {
    console.log(error);
    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(error.json());
    }
  }

  deleteToken() {
    const headerParams = MakerService.headers;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this.http
        .delete(`${apiUrl}/auth/token`, { headers: MakerService.headers })
        .subscribe(() => {});
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/maker.service.ts